import React from "react";
import { Card } from "reactstrap";
import "./index.css";
import NoResultFoundSearch from "Components/CommonComponents/NoResultFoundSearch/NoResultFoundSearch";
import DataNotFound from "Assets/Icons/DataNotFound";
import ScheduledLectureCard from "utilFunctions/shared/ScheduledLectureCard";
import { convertTime } from "utilFunctions/helperFunctions/convertTime";
import Typography from "Components/CommonComponents/Typography";
interface IMySchedulecardList {
  scheduleData?: any;
  screen?: any;
  handleMarkSyllbus?: any;
  detailShowHandler?: any;
  selectedDate: any;
  dateRanges?: any;
  filterState?: any;
}
function MySchedulecardList({
  scheduleData,
  screen,
  handleMarkSyllbus,
  detailShowHandler,
  selectedDate,
  dateRanges,
  filterState,
}: IMySchedulecardList) {
  //const [cardListData, setCardListData]=useState<any>(scheduleData?scheduleData:[]);
  const cardListData = scheduleData;

  return (
    <Card
      className={
        ["xs", "sm", "md"].includes(screen)
          ? "cardListContainerMB"
          : "cardListContainer"
      }
    >
      <Typography variant="semiboldheading" color={"black"}>
        {selectedDate && convertTime(selectedDate, "D MMM, ddd")}
      </Typography>

      {cardListData && cardListData.length > 0 ? (
        <div className="mt-3">
          {cardListData.map((item: any, index: any) => {
            return (
              <>
                <ScheduledLectureCard
                  cardData={item}
                  screen={screen}
                  cardIndex={index}
                  handleMarkSyllbus={handleMarkSyllbus}
                  mode="schedule"
                  buttonCSS={
                    ["xs", "sm", "md"].includes(screen)
                      ? "scheduledButtonCSS"
                      : ""
                  }
                  detailShowHandler={detailShowHandler}
                  dateRanges={dateRanges}
                  filterState={filterState}
                />
              </>
            );
          })}
        </div>
      ) : (
        <div className="d-flex justify-content-center align-items-center h-100">
          <NoResultFoundSearch
            primaryMessage="No scheduled lectures."
            secondaryMessage={
              "No lectures assigned to your Employee ID in Phoenix for the selected date range. Contact your EDP team for assistance."
            }
          >
            <DataNotFound />
          </NoResultFoundSearch>
        </div>
      )}
    </Card>
  );
}

export default MySchedulecardList;
